<button
  [type]="type"
  [class]="buttonClasses"
  [disabled]="disabled || loading"
  (click)="handleClick($event)"
>
  <span class="app-button__content">
    <span *ngIf="loading" class="app-button__spinner">
      <svg class="spinner" viewBox="0 0 50 50">
        <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
      </svg>
    </span>
    
    <span 
      *ngIf="iconPath && !loading && iconPosition === 'left'" 
      class="app-button__icon"
      [attr.data-icon]="iconPath">
    </span>
    
    <span class="app-button__text">
      <ng-content></ng-content>
    </span>
    
    <span 
      *ngIf="iconPath && !loading && iconPosition === 'right'" 
      class="app-button__icon"
      [attr.data-icon]="iconPath">
    </span>
  </span>
</button>